// api.js
import axios from "axios"
import { baseURL } from "constants/constants"

const apiGet = async (pathname) => {
  try {
    const response = await axios.get(`${baseURL}/${pathname}`)
    return response.data
  } catch (error) {
    console.error(`Ошибка при выполнении запроса ${pathname}:`, error)
    throw error
  }
}

export const getSettings = (restaurant_id) =>
  apiGet(`settings/${restaurant_id}`)

export const getTypes = (restaurant_id) => apiGet(`types/${restaurant_id}`)

export const getGroups = (restaurant_id) => apiGet(`groups/${restaurant_id}`)

export const getReastaurant = (restaurant_id) =>
  apiGet(`restaurants/${restaurant_id}`)

export const getDishes = (restaurant_id) => apiGet(`dishes/${restaurant_id}`)
export const getAddons = (dish_id) => apiGet(`dishes/${dish_id}/addons`)
export const getChoices = (dish_id) => apiGet(`dishes/${dish_id}/choices`)
export const getRestaurants = () => apiGet(`restaurants/`)
